import { getPlatformNameKfc, getHeadImgKfc } from '@/utils/auth'
const state = {
  platformNameKfc: getPlatformNameKfc(),
  headImgKfc: getHeadImgKfc(),
}

const mutations = {
  SET_PLATFORM_NAME_KFC:(state, platformNameKfc)=>{
    state.platformNameKfc = platformNameKfc
  },
  SET_HEAD_IMG_KFC:(state, headImgKfc)=>{
    state.headImgKfc = headImgKfc
  },
}

const actions = {
  changePlatformNameKfc({ commit }, platformNameKfc) {
    commit('SET_PLATFORM_NAME_KFC', platformNameKfc)
  },
  changeHeadImgKfc({ commit }, headImgKfc) {
    commit('SET_HEAD_IMG_KFC', headImgKfc)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/kfc.js